import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { Store } from 'redux';
import type { RootState, AppThunkDispatch } from 'store/store';

export const useThunkDispatch: () => AppThunkDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => Store<RootState> = useStore;
